/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_Further_Boiler_Room_DescriptionInputs */



/**
* | output |
* | --- |
* | "Follow temperatures, boiler and pump status live, adjust your heating network setpoints and spot a fault as soon as it occurs." |
*
* @param {Go_Further_Boiler_Room_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const go_further_boiler_room_description = /** @type {((inputs?: Go_Further_Boiler_Room_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_Further_Boiler_Room_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Follow temperatures, boiler and pump status live, adjust your heating network setpoints and spot a fault as soon as it occurs.")
	return /** @type {LocalizedString} */ ("Suivez en direct les températures, l'état des chaudières et des pompes, ajustez les consignes de vos réseaux et repérez un défaut dès qu'il apparaît.")
});